import { Route, RouterProvider, Routes, createBrowserRouter } from "react-router-dom"
import { Authenticator, withAuthenticator, useAuthenticator } from "@aws-amplify/ui-react"
import '@aws-amplify/ui-react/styles.css';
import { useState } from "react";
import Loading from "./components/loading";
import LandingPage from "./components/LandingPage";
import Root from "./layouts/root";
import Dashboard from "./pages/dashboard";
import Courses from "./pages/courses";
import Profile from "./pages/profile";
import Callback from "./pages/callback";
import AppLayout from "./layouts/appLayout";
import AppMenu from "./pages/appMenu";
import Deploy from "./pages/deploy";
import MediaManager from './pages/mediaManager.tsx'
import Editor from "./pages/editor";
import UserManagement from "./pages/userManagement";
import SupportTickets from "./pages/supportTickets";
import Broadcasts from "./pages/broadcasts";
import MobileBanner from "./pages/mobileBanner";
import QuizDashboard from "./pages/quizDashboard";
import FlashcardDashboard from "./pages/flashcardDashboard";
import MediaHub from "./pages/mediaHub";
import QuestionBank from "./pages/questionBank";
import GlobalLogs from "./pages/globalLogs";
import EnterprisePage from "./pages/enterprise";
import FinancialManagement from "./pages/financialManagement";
import CourseAnalytics from "./pages/courseAnalytics";

const router = createBrowserRouter([
	{
		path: '/',
		element: <Root />,
		children: [
			{
				index: true,
				element: <Dashboard />
			},
			{
				path: "/courses",
				element: <Courses />
			},
			{
				path: "/media-hub",
				element: <MediaHub />
			},
			{
				path: "/profile",
				element: <Profile />
			},
			{
				path: "/users",
				element: <UserManagement />
			},
			{
				path: "/tickets",
				element: <SupportTickets />
			},
			{
				path: "/broadcasts",
				element: <Broadcasts />
			},
			{
				path: "/mobile-banner",
				element: <MobileBanner />
			},
			{
				path: "/quizzes",
				element: <QuizDashboard />
			},
			{
				path: "/question-bank",
				element: <QuestionBank />
			},
			{
				path: "/flashcards",
				element: <FlashcardDashboard />
			},
			{
				path: "/logs",
				element: <GlobalLogs />
			},
			{
				path: "/enterprise",
				element: <EnterprisePage />
			},
			{
				path: "/accounts",
				element: <FinancialManagement />
			},
			{
				path: "/accounts/dashboard",
				element: <FinancialManagement />
			},
			{
				path: "/accounts/android",
				element: <FinancialManagement />
			},
			{
				path: "/accounts/ios",
				element: <FinancialManagement />
			},
			{
				path: "/accounts/receipts",
				element: <FinancialManagement />
			},
			{
				path: "/finance",
				element: <FinancialManagement />
			},
			{
				path: "/analytics",
				element: <CourseAnalytics />
			},
			{
				path: "/analytics/:courseId",
				element: <CourseAnalytics />
			},
			{
				path: "/callback",
				element: <Callback />
			},
			{
				path: "/:appId",
				element: <AppLayout />,
				children: [
					{
						index: true,
						element: <AppMenu />
					},
					{
						path: 'analytics',
						element: <CourseAnalytics />
					},
					{
						path: 'media',
						element: <MediaManager />
					},
					{
						path: 'editor',
						element: <Editor />
					},
					{
						path: 'deploy',
						element: <Deploy />
					},
				]
			}
		]
	}
])
function AppContent() {
	const { authStatus } = useAuthenticator((context) => [context.authStatus]);
	const [activeTab, setActiveTab] = useState<'home' | 'about' | 'terms' | 'privacy' | 'login'>('home');

	if (authStatus === 'configuring') {
		return <Loading message="Loading application..." fullScreen />;
	}

	if (authStatus === 'authenticated') {
		return <RouterProvider router={router} />;
	}

	return (
		<LandingPage activeTab={activeTab} setActiveTab={setActiveTab} />
	);
}

export default function App() {
	return (
		<Authenticator.Provider>
			<AppContent />
		</Authenticator.Provider>
	);
} 
